import { Grid2, Stack } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';

import { useParameter } from '@hooks/useParameter';
import useReferenceRange from '@hooks/useReferenceRange';

import { displayFriendlyRiskLevel } from '@utils/reference_range';
import { determineExpression } from '@utils/reference_range';

import type {
  ReferenceRangeRiskLevel,
  ReferenceRangeRiskModel,
} from 'generated/types';

import ParameterForm from './ParameterForm';
import RiskCard from './RiskCard';

interface RiskCardProps {
  parameter: ReferenceRangeRiskModel;
  risk: ReferenceRangeRiskLevel;
}

export default function RiskForm({ parameter, risk }: RiskCardProps) {
  const { formatMessage } = useIntl();
  const { code } = useParameter();
  const { parameterMap } = useReferenceRange();

  const messageId = displayFriendlyRiskLevel(code, risk);
  const title = messageId ? formatMessage({ id: messageId }) : '';

  const parameterValues = parameter.parameters.map((p) => {
    return {
      parameter_id: p.parameter_id,
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      code: p.code || code,
      vitall_patient_id: p.vitall_patient_id,
      lower_bound: p.lower_bound?.value,
      upper_bound: p.upper_bound?.value,
      expression: determineExpression(p),
    };
  });

  return (
    <Grid2 size={{ xs: 12, sm: 6, lg: 4 }} height="100%">
      <Stack spacing={1} alignItems="center">
        <RiskCard color={parameterMap[risk].colour} title={title} />
        <ParameterForm risk={risk} values={parameterValues} />
      </Stack>
    </Grid2>
  );
}
